// extracted by mini-css-extract-plugin
export default {"list":"style_list__JhGkf","row":"style_row__SiTCc","loanNo":"style_loanNo__hYDXE","paidSummary":"style_paidSummary__55VtX","nextRound":"style_nextRound__1kQJ4"};